import angular, { IScope } from 'angular';
import { IStateProvider } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.maintenance').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.maintenanceUsers, {
    url: '/users',
    params: { flowId: null, title: 'Maintenance - Users' },
    views: {
      childcontent: {
        templateUrl:
          'Client/runner.maintenance/users/runner.maintenance.users.tmpl.html',
        controllerAs: '$ctrl',
        controller: [
          '$scope',
          function ($scope: IScope) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const $ctrl = this;

            $ctrl.selectedBusinessId = null;

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $scope.$parent.$watch('$ctrl.selectedBusiness', (value: any) => {
              $ctrl.selectedBusinessId = value?.id;
            });

            $ctrl.handleGridNeedResize = () => {
              // This is a callback from React component
              // Could be used to trigger any parent-level actions if needed
            };
          }
        ]
      }
    }
  });
}
